/* eslint-disable react/require-default-props */

import React, { useState, useEffect, useContext } from 'react';
import proptypes from 'prop-types';
const { bool, string } = proptypes;
import { useConfigService } from '@thd-nucleus/experience-context';
import { extend, QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { useBundleMiniFbtLayout } from '../hooks/useBundleMiniFbtLayout';
import { shouldDisplayFBTPMV, isPackageRecommendationFlag,
  isProductAvailable, shouldDisplayConfigurator } from '../utils/product-utils';
import { BundleMini } from './BundleMini';
import { useBundle } from '../hooks/useBundle';
import { BundleFbt } from '../subcomponents/BundleFbt';
import { PackageMiniGM } from '../subcomponents/PackageMiniGM';
import { PackagesMiniAbTest } from '../subcomponents/PackagesMiniAbTest';
import { BundleMiniContextProvider } from '../context/BundleMiniContext';

const BundlePmvFbtLayoutGmAndHdh = ({ itemId = '', name = '', showOnlyBundleEntry = false }) => {

  const { productData, isServer } = useBundleMiniFbtLayout({ itemId });
  const displayConfigurator = shouldDisplayConfigurator(productData, isServer);
  const { defaultVariables } = useContext(QueryContext);
  const [isPMVEnabled, setIsPMVEnabled] = useState(false);
  const [isFBTEnabled, setIsFBTEnabled] = useState(false);
  const [isPMVAndFBTEnabled, setIsPMVAndFBTEnabled] = useState(false);
  const abcTestEnable = useConfigService('fs:isABCTestEnable');
  const hasOneActiveABCTest = [isPMVEnabled, isFBTEnabled, isPMVAndFBTEnabled].filter((val) => !!val).length === 1;

  const { bundleIds } = useBundle({ product: productData?.product });

  useEffect(() => {
    shouldDisplayFBTPMV(setIsPMVEnabled, setIsFBTEnabled, setIsPMVAndFBTEnabled);
  }, []);

  if (!productData || displayConfigurator) {
    return null;
  }

  const { product } = productData || {};
  const availableProduct = isProductAvailable(product, abcTestEnable);
  const isPackage = isPackageRecommendationFlag(product);
  if (!availableProduct) {
    return null;
  }

  if (bundleIds) {
    return (
      <>
        <BundleMiniContextProvider itemId={itemId}>
          <QueryProvider
            cacheKey="bundle-mini-provider"
            defaultVariables={defaultVariables.current}
          >
            <BundleMini bundleIds={bundleIds} />
          </QueryProvider>
        </BundleMiniContextProvider>
      </>
    );
  }

  if (abcTestEnable && (isPackage)) {
    if (hasOneActiveABCTest) {
      return (
        <>
          {isPMVEnabled && (
            <PackageMiniGM itemId={itemId} name={name} />
          )}
          {isFBTEnabled && (
            <BundleFbt
              itemId={itemId}
              name={name}
            />
          )}
          {isPMVAndFBTEnabled && (
            <>
              <PackageMiniGM itemId={itemId} name={name} />
              <BundleFbt
                itemId={itemId}
                name={name}
              />
            </>
          )}
        </>
      );
    }
    return null;
  }

  if (isPackage) {
    return (
      <>
        <PackageMiniGM itemId={itemId} name={name} />
      </>
    );
  }

  if (showOnlyBundleEntry) {
    return null;
  }

  return (
    <BundleFbt
      itemId={itemId}
      name={name}
    />
  );
};

BundlePmvFbtLayoutGmAndHdh.propTypes = {
  itemId: string,
  name: string,
  showOnlyBundleEntry: bool
};

BundlePmvFbtLayoutGmAndHdh.dataModel = extend(
  BundleFbt,
  PackagesMiniAbTest
);

BundlePmvFbtLayoutGmAndHdh.displayName = 'BundlePmvFbtLayoutGmAndHdh';

export { BundlePmvFbtLayoutGmAndHdh };